// FASTAG PRICING
export const FASTAG_PRICING_REQUEST = "FASTAG_PRICING_REQUEST";
export const FASTAG_PRICING_SUCCESS = "FASTAG_PRICING_SUCCESS";
export const FASTAG_PRICING_FAILURE = "FASTAG_PRICING_FAILURE";
export const TRANSFER_TAG = "TRANSFER_TAG";
export const FETCH_USER_DETAILS_BY_ID = "FETCH_USER_DETAILS_BY_ID";
export const ADD_CASHBACK = "ADD_CASHBACK";
export const DELETE_CASHBACK = "DELETE_CASHBACK";
export const RE_ASSIGN_USER = "RE_ASSIGN_USER";
export const TOA_TAG_ORDERS = "TOA_TAG_ORDERS";
export const APPROVE_TAG_ORDER = "APPROVE_TAG_ORDER";
export const UPLOAD_TAG_ORDER = "UPLOAD_TAG_ORDER";
export const GET_USER_ANALYTICS = "GET_USER_ANALYTICS";